export default "__VITE_ASSET__DUBog021__"